import React, {useEffect, useState, useRef } from 'react';
import avatar from '../data/avatar6.png'
import { useStateContext } from '../contexts/ContextProvider';
import { AnimatePresence } from 'framer-motion';


import { InputAdornment, IconButton, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ProfileDropdown from './ProfileDropdown';
import Logo from '../data/discount_logo.png'
import { Link } from 'react-router-dom'; // Import Link



const Navbar = () => {
  const { searchTerm, setSearchTerm } = useStateContext(); // Destructure the needed states and functions
  
  const searchInputRef = useRef(null); // Create a ref for the TextField

  const [profileVisible, setProfileVisible ] = useState(false);
  const profileRef = useRef(null);
  const dropdownRef = useRef(null);
  const navbarRef = useRef(null);
  const logoRef = useRef(null);

  const [rotate, setRotate] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);
  const [searchBarMarginLeft, setSearchBarMarginLeft] = useState(0);


  const focusSearchInput = () => {
    searchInputRef.current.focus();
  };


  const handleLogoClick = () => {
    setRotate(true);
    // Reset the animation
    setTimeout(() => setRotate(false), 1000);
  };

  useEffect(() => {
    const handleResize = () => {
      if (navbarRef.current && logoRef.current && profileRef.current) {
        const navbarWidth = navbarRef.current.offsetWidth;
        const logoWidth = logoRef.current.offsetWidth;
        const profileWidth = profileRef.current.offsetWidth;

        const availableSpace = navbarWidth - logoWidth - profileWidth-25;
        const searchWidth = 50; // Width of the search bar when collapsed
        setSearchBarMarginLeft(availableSpace - searchWidth);
        console.log(availableSpace);
        console.log("navbar width", navbarWidth);
        console.log("logoWidth", logoWidth);
        console.log("profileWidth", profileWidth);


      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);



  const handleCloseDropdown = () => {
    setProfileVisible(false);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
 };

 const handleSearchSubmit = (event) => {
  event.preventDefault();
  // Implement your search logic here
  console.log('Search term submitted:', searchTerm);
  };

  const handleSearchFocus = () => {
    setSearchFocused(true);
  };

  const handleSearchBlur = () => {
    if (!searchTerm) {
      setSearchFocused(false);
    }
  };

  return (
    <div ref={navbarRef} className='flex justify-between p-1  z-100   bottom-shadow'>

        {/* Logo */}
        <div ref={logoRef} className='flex items-center pl-4 pt-2'>
            <Link to="/"> 
              <img src={Logo} alt="Discount Logo" 
                   className={`w-10 h-10 mr-2 ${rotate ? 'rotate-animation' : ''}`}
                   onClick={handleLogoClick} />
            </Link>
        </div>

        
        {/* Search Bar */}
        <div className={`search-container ${searchFocused ? 'expanded' : 'collapsed'}`  } style={{
          transition: 'width 0.5s, margin-left 0.5s',
          width: searchFocused ? '80%' : '50px',
          marginLeft: searchFocused ? '0' : searchBarMarginLeft // Adjust '25px' if your icon size is different
        }}>
        <form onSubmit={handleSearchSubmit} style={{ width: '80%' }}>
            <TextField
              inputRef={searchInputRef}

              fullWidth
              variant="outlined"
              size="small"
              placeholder=""
              value={searchTerm}
              onChange={handleSearchChange}
              onFocus={handleSearchFocus}
              onBlur={handleSearchBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton onClick={focusSearchInput}>
                      <SearchIcon  /> {/* This will set the icon color to the default action color */}
                    </IconButton>
                  </InputAdornment>
                ),
                // The 'style' property here is not needed as we are controlling the border with 'sx'
              }}
              // Apply additional styles on focus and hover
              sx={{
                  '& .MuiOutlinedInput-root': {
                    paddingLeft: 0, // Set padding to 0 with !important
                    '& fieldset': {
                      borderColor: 'transparent', // Hide border by default
                    },
                    '&:hover fieldset': {
                      borderColor: 'black', // Show border slightly on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'black', // Show border in black when focused
                    },
                  },
                  '& .MuiSvgIcon-root': { // This targets all SVG icons inside the TextField
                    color: 'black', // Here we set the color of the icon
                  }
                }}
            />
          </form>
        </div>

        {/* Profile */}
        <div  className='flex flex-1 justify-end'>
          <div ref={profileRef} className='flex items-center gap-1 cursor-pointer p-2 sm:hover:bg-blue4 rounded-lg mr-2'
          onClick={() => setProfileVisible(prev => !prev)}
          
          >
            <img src = {avatar}  className='rounded-full w-8 h-8' />
            <p>
              <span className='text-poly-green  font-semibold ml-1 text-14'>  </span>
            </p>
            <KeyboardArrowDownIcon className='text-black text-12'/>
          </div>
          <AnimatePresence>
          {profileVisible && <ProfileDropdown  onClose={handleCloseDropdown}  dropdownRef={dropdownRef} profileRef={profileRef}/>}
          </AnimatePresence>

        </div>

        
    </div>
  )
}


export default Navbar